import { useApiMutation } from "hooks/useApi/useApiHooks";
import { FC, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IPaymentStatus } from "../types";
import { TextInput } from "components";
import { Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";

interface IPaymentStatusForm {
  formStore: UseFormReturn<IPaymentStatus>;
  edit?: IPaymentStatus;
  resetForm: () => void;
}

const PaymentStatusForm: FC<IPaymentStatusForm> = ({
  formStore,
  edit,
  resetForm,
}) => {
  const { control, handleSubmit, reset, setValue, watch } = formStore;

  const { mutate, status, data } = useApiMutation<IPaymentStatus>(
    "payment-status",
    edit ? "put" : "post"
  );

  const submit = (data: IPaymentStatus) => {
    mutate({ ...data });
  };

  useEffect(() => {
    if (status === "success") {
      resetForm();
    }
  }, [status, data]);

  useEffect(() => {
    if (edit) {
      reset({
        _id: edit._id,
        color: edit.color,
        text: edit.text,
        type: edit.type,
      });
    }
  }, [edit]);

  const { t } = useTranslation();


  return (
    <form
      id="add-payment-status"
      className="w-96"
      onSubmit={handleSubmit(submit)}
    >
      <TextInput
        control={control}
        name="text"
        label={t("general.name")!}
      />
      <TextInput
        control={control}
        name="color"
        label={t("general.color")!}
        type="color"
        rules={{ required: false }}
      />
      <Grid item xs={12} md={12}>
        <FormControl component="fieldset" className="mt-4">
          {/* <FormLabel component="legend">{t("general.type")}</FormLabel> */}
          <RadioGroup
            name="type"
            onChange={(e) => setValue("type", e.target.value)}
            value={watch("type") || ""}
          >
            <FormControlLabel
              value="paid"
              control={<Radio />}
              label={t("general.paid")}
            />
            <FormControlLabel
              value="unpaid"
              control={<Radio />}
              label={t("general.unpaid")}
            />
            <FormControlLabel
              value="partiallyPaid"
              control={<Radio />}
              label={t("general.partiallyPaid")}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </form>
  );
};

export default PaymentStatusForm;
